/** * @file FormLabel */
<template>
  <label class="fix_label"><slot /></label>
</template>

<script>
export default {}
</script>
